import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchTransaction = async (transactionId: string) => {
  const response = await queryExecute({
    variables: {
      id: transactionId,
    },
    fetchPolicy: 'no-cache',
    query: graphql(`
      query Transaction($id: String!) {
        transaction(id: $id) {
          id
          date
          category
          description
          notes
          currency
          amount
          associatedObjectType
          associatedObjectId
          createdAt
          updatedAt
          status
          errorCode
          ipAddress
          ipCountry
          device
          operatingSystem
          browser
          user {
            firstName
            lastName
            role
          }
          distributions {
            transactionId
            sortOrder
            class
            account
            amount
            associatedObjectType
            associatedObjectId
            stripeCustomerId
            stripeChargeId
            stripeRefundId
            createdAt
            status
          }
        }
      }
    `),
  });

  return response.data.transaction;
};
